import { render, staticRenderFns } from "./HkVideo.vue?vue&type=template&id=5acad64b&scoped=true&"
import script from "./HkVideo.vue?vue&type=script&lang=js&"
export * from "./HkVideo.vue?vue&type=script&lang=js&"
import style0 from "./HkVideo.vue?vue&type=style&index=0&id=5acad64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acad64b",
  null
  
)

export default component.exports